var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#image_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 77.188,
    height: 77.188,
    x: -10.594,
    y: -7.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#image_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#image_svg__c)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image_svg__d)",
    fillOpacity: 0.2,
    d: "M0 12.8c0-4.48 0-6.72.872-8.432A8 8 0 0 1 4.368.872C6.08 0 8.32 0 12.8 0h30.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 6.08 56 8.32 56 12.8v30.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C49.92 56 47.68 56 43.2 56H12.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C0 49.92 0 47.68 0 43.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#image_svg__e)",
    d: "M0 12.8c0-4.48 0-6.72.872-8.432A8 8 0 0 1 4.368.872C6.08 0 8.32 0 12.8 0h30.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 6.08 56 8.32 56 12.8v30.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C49.92 56 47.68 56 43.2 56H12.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C0 49.92 0 47.68 0 43.2z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.375,
    d: "M12.8.188h30.4c2.243 0 3.915 0 5.24.108 1.322.108 2.282.323 3.107.743a7.8 7.8 0 0 1 3.414 3.414c.42.825.635 1.785.743 3.108s.108 2.996.108 5.239v30.4c0 2.243 0 3.915-.108 5.24-.108 1.322-.323 2.282-.743 3.107a7.8 7.8 0 0 1-3.414 3.414c-.825.42-1.785.635-3.107.743-1.325.108-2.997.108-5.24.108H12.8c-2.243 0-3.915 0-5.24-.108-1.322-.108-2.282-.323-3.107-.743a7.8 7.8 0 0 1-3.414-3.414c-.42-.825-.635-1.785-.743-3.107-.108-1.325-.108-2.997-.108-5.24V12.8c0-2.243 0-3.915.108-5.24.108-1.322.323-2.282.743-3.107A7.8 7.8 0 0 1 4.453 1.04C5.278.62 6.238.404 7.561.296S10.557.188 12.8.188Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 89.059,
    height: 68.577,
    x: -1.529,
    y: 8.665
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#image_svg__f)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#image_svg__g)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image_svg__h)",
    d: "M37.905 20.705c1.73-2.279 2.597-3.418 3.655-3.826a4 4 0 0 1 2.88 0c1.058.408 1.924 1.547 3.655 3.825l25.098 33.024c2.51 3.302 3.765 4.953 3.742 6.337a4 4 0 0 1-1.527 3.08C74.32 64 72.246 64 68.098 64H17.902c-4.149 0-6.223 0-7.31-.855a4 4 0 0 1-1.528-3.08c-.023-1.383 1.232-3.035 3.742-6.337z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M41.627 17.054a3.8 3.8 0 0 1 2.746 0c.49.189.947.55 1.504 1.163.558.613 1.201 1.46 2.07 2.601l25.097 33.023c1.257 1.654 2.191 2.885 2.81 3.875.621.992.904 1.712.894 2.346a3.81 3.81 0 0 1-1.456 2.935c-.5.393-1.244.603-2.41.71-1.162.105-2.707.105-4.784.105H17.902c-2.077 0-3.622 0-4.785-.106-1.165-.106-1.91-.316-2.409-.709a3.81 3.81 0 0 1-1.456-2.934c-.01-.636.273-1.355.893-2.347.62-.99 1.554-2.22 2.811-3.875l25.098-33.023c.867-1.141 1.51-1.988 2.069-2.601.557-.612 1.015-.974 1.504-1.163Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 89.059,
    height: 68.577,
    x: -30.529,
    y: 16.665
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#image_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#image_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image_svg__k)",
    fillOpacity: 0.5,
    d: "M8.905 28.705c1.73-2.279 2.597-3.418 3.655-3.826a4 4 0 0 1 2.88 0c1.058.408 1.924 1.547 3.655 3.825l25.098 33.024c2.51 3.302 3.765 4.953 3.742 6.337a4 4 0 0 1-1.527 3.08C45.32 72 43.246 72 39.098 72h-50.195c-4.149 0-6.223 0-7.31-.855a4 4 0 0 1-1.528-3.08c-.023-1.383 1.232-3.035 3.742-6.337z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#image_svg__l)",
    fillOpacity: 0.25,
    d: "M8.905 28.705c1.73-2.279 2.597-3.418 3.655-3.826a4 4 0 0 1 2.88 0c1.058.408 1.924 1.547 3.655 3.825l25.098 33.024c2.51 3.302 3.765 4.953 3.742 6.337a4 4 0 0 1-1.527 3.08C45.32 72 43.246 72 39.098 72h-50.195c-4.149 0-6.223 0-7.31-.855a4 4 0 0 1-1.528-3.08c-.023-1.383 1.232-3.035 3.742-6.337z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.375,
    d: "M12.627 25.054a3.8 3.8 0 0 1 2.746 0c.49.189.947.55 1.504 1.163.558.613 1.201 1.46 2.07 2.601l25.097 33.023c1.257 1.654 2.191 2.885 2.81 3.875.621.992.904 1.712.894 2.347a3.81 3.81 0 0 1-1.456 2.934c-.5.393-1.244.603-2.41.71-1.162.105-2.707.106-4.784.106h-50.196c-2.077 0-3.622-.001-4.785-.107-1.165-.106-1.91-.316-2.409-.709a3.81 3.81 0 0 1-1.456-2.934c-.01-.636.273-1.355.893-2.347.62-.99 1.554-2.22 2.811-3.875L9.054 28.818c.867-1.141 1.51-1.988 2.069-2.601.557-.612 1.015-.974 1.504-1.163Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "image_svg__b",
    transform: "translate(10.594 7.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8c0-4.48 0-6.72.872-8.432A8 8 0 0 1 4.368.872C6.08 0 8.32 0 12.8 0h30.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 6.08 56 8.32 56 12.8v30.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C49.92 56 47.68 56 43.2 56H12.8c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C0 49.92 0 47.68 0 43.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "image_svg__f",
    transform: "translate(1.53 -8.665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.905 20.705c1.73-2.279 2.597-3.418 3.655-3.826a4 4 0 0 1 2.88 0c1.058.408 1.924 1.547 3.655 3.825l25.098 33.024c2.51 3.302 3.765 4.953 3.742 6.337a4 4 0 0 1-1.527 3.08C74.32 64 72.246 64 68.098 64H17.902c-4.149 0-6.223 0-7.31-.855a4 4 0 0 1-1.528-3.08c-.023-1.383 1.232-3.035 3.742-6.337z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "image_svg__i",
    transform: "translate(30.53 -16.665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.905 28.705c1.73-2.279 2.597-3.418 3.655-3.826a4 4 0 0 1 2.88 0c1.058.408 1.924 1.547 3.655 3.825l25.098 33.024c2.51 3.302 3.765 4.953 3.742 6.337a4 4 0 0 1-1.527 3.08C45.32 72 43.246 72 39.098 72h-50.195c-4.149 0-6.223 0-7.31-.855a4 4 0 0 1-1.528-3.08c-.023-1.383 1.232-3.035 3.742-6.337z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8a8 8 0 0 1 8-8h40a8 8 0 0 1 8 8v40a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "image_svg__d",
    x1: 28,
    x2: 28,
    y1: 24.85,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "image_svg__h",
    x1: 45.375,
    x2: 45.375,
    y1: 14.735,
    y2: 97.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "image_svg__k",
    x1: 14,
    x2: 14,
    y1: 44.188,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "image_svg__c",
    width: 77.188,
    height: 77.188,
    x: -10.594,
    y: -7.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "image_svg__g",
    width: 89.059,
    height: 68.577,
    x: -1.529,
    y: 8.665,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "image_svg__j",
    width: 89.059,
    height: 68.577,
    x: -30.529,
    y: 16.665,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "image_svg__e",
    width: 1.143,
    height: 1.143,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image_svg__m",
    transform: "scale(.00112)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "image_svg__l",
    width: 0.842,
    height: 1.28,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image_svg__m",
    transform: "scale(.00082 .00125)"
  })))));
};
export default SvgImage;